/* ═══ AgFab — Anagogia Design System ═══ */

import { forwardRef } from 'react';
import styles from './AgFab.module.css';

interface AgFabProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** Taille : lg = 56px (action principale), sm = 48px (raccourci) */
  size?: 'lg' | 'sm';
  /** primary = plein (couleur primaire) ; secondary = tonal (fond teinté, bordure et icône primaires) */
  variant?: 'primary' | 'secondary';
  /** Icône (lucide-react) */
  children: React.ReactNode;
  /** Libellé accessible — obligatoire, le bouton n'a pas de texte visible */
  'aria-label': string;
}

/**
 * Bouton d'action flottant, rond et ombré. Ne se positionne pas lui-même :
 * le conteneur qui le place porte la position et la strate (ex. l'emplacement
 * central d'`AgTabBar`, bouton « Capturer » du shell mobile).
 * @category Boutons
 */
const AgFab = forwardRef<HTMLButtonElement, AgFabProps>(function AgFab(
  { size = 'lg', variant = 'primary', type = 'button', children, className, ...rest },
  ref,
) {
  const cls = [styles.fab, styles[variant], styles[size], className].filter(Boolean).join(' ');
  return (
    <button ref={ref} type={type} className={cls} {...rest}>
      {children}
    </button>
  );
});

export { AgFab };
export type { AgFabProps };
export default AgFab;
